import type { ReactNode } from 'react';

import { colors } from '#/theme/theme';

import {
  MultiStepFormLayout_Box_1,
  MultiStepFormLayout_Box_2,
} from './MultiStepFormLayout.styled';

function Container({
  children,
  hasSidebar,
}: {
  children: ReactNode;
  hasSidebar: boolean;
}) {
  if (hasSidebar) return <div style={{ display: 'flex' }}>{children}</div>;

  // oxlint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}

type Props = {
  sidebar?: ReactNode;
  children: ReactNode;
};

export function MultiStepFormLayout({ sidebar, children }: Props) {
  const hasSidebar = Boolean(sidebar);
  return (
    <Container hasSidebar={hasSidebar}>
      <MultiStepFormLayout_Box_2
        data-has-sidebar={hasSidebar ? true : undefined}
        style={{ maxWidth: sidebar ? 856 : 'none' }}
      >
        <div
          style={{
            minHeight: hasSidebar ? 'calc(100vh - 150px)' : undefined,
            height: '100%',
          }}
        >
          {children}
        </div>
      </MultiStepFormLayout_Box_2>

      {sidebar && (
        <MultiStepFormLayout_Box_1>
          <div
            style={{
              position: 'sticky',
              right: 0,
              top: 'var(--root-padding-top)',
              maxWidth: 572,
              minHeight: '100vh',
              display: 'flex',
              alignItems: 'center',
              background: colors.backgroundGrey,
            }}
          >
            {sidebar}
          </div>
        </MultiStepFormLayout_Box_1>
      )}
    </Container>
  );
}
